module.exports = __webpack_public_path__ + "static/media/local_pharmacy_dropdown.9b0fa72e.svg";